import React, { useContext } from 'react';
import { useLocalize } from '@core-ui/localization-provider';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';
import { PageDataContext } from '../../providers/page-data-provider/index';
import { useBRRedesign } from '../../hooks/br-redesign.hook';
import { StyledButton, StyledDiv } from './styles';

const ClearAllButtonContainer = (): JSX.Element => {
  const { clearAllFilters } = useContext(PageDataContext);
  const { localize } = useLocalize();
  const isBRRedesignEnabled = useBRRedesign();
  const buttonText = isBRRedesignEnabled ? localize('left_rail_lhf.clear_filter_button') : localize('facet_bar.clear_all_button');

  const { minWidth } = useContext(BreakpointContext);
  const isXLarge = minWidth(XLARGE);

  return (
    <StyledDiv>
      <StyledButton
        disabled={false}
        isXLarge={isXLarge}
        onClick={clearAllFilters}
        isBRRedesignEnabled={isBRRedesignEnabled}
      >
        {buttonText}
      </StyledButton>
    </StyledDiv>
  );
};

export default ClearAllButtonContainer;
